import { render, staticRenderFns } from "./nxMobileVideo.vue?vue&type=template&id=5aa85dfe&scoped=true&"
import script from "./nxMobileVideo.vue?vue&type=script&lang=js&"
export * from "./nxMobileVideo.vue?vue&type=script&lang=js&"
import style0 from "./nxMobileVideo.vue?vue&type=style&index=0&id=5aa85dfe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa85dfe",
  null
  
)

export default component.exports